import React, { memo } from "react";
import { Stack, Typography, Card, CardContent, Box, Tooltip, Icon } from "investira.react.components";
import FinanceiroChart from "./FinanceiroChart";
const FinanceiroSection = memo(props => {
  const {
    data = [],
    title = "",
    pessoa = {}
  } = props;
  return <Stack spacing={2} sx={{
    py: 2
  }} component="section" aria-label={`${title}: ${pessoa.pessoa_fantasia || pessoa.pessoa}`}>
      <Card sx={{
      height: "100%"
    }}>
        <CardContent sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}>
          <Stack alignItems="space-between" direction="row">
            <Stack flexGrow={1}>
              <Typography variant="subtitle1" color="textPrimary" sx={{
              fontWeight: 600
            }} component="h3">
                {title}
              </Typography>
            </Stack>
            <Stack alignItems="center" justifyContent="center">
              <Tooltip title={`${title} mais relevantes`}>
                <Box sx={{
                width: "16px",
                height: "16px"
              }}>
                  <Icon iconName="information" size={16} color="primary" />
                </Box>
              </Tooltip>
            </Stack>
          </Stack>
          <Stack direction={{
          xs: "column",
          md: "row"
        }} py={1}>
            <Stack sx={{
            flex: 1,
            minWidth: 0
          }}>
              <FinanceiroChart data={data} />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>;
});
export default FinanceiroSection;
